<div class="">
  <table class="table table-hover table-center mb-0">
    <thead>
      <tr>
        <th style="width: 10%">Patient</th>
        <th style="width: 10%">Date</th>
        <th>Motif Consultation</th>
        <th style="width: 100% !important">Diagnostic</th>
        <th *ngIf="doctor.speciality.label=='Ophtalmologue' && doctor.cliniqueId">Payé</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngIf="doctorConsultations.length; else empty">
        <tr *ngFor="
            let consultation of doctorConsultations
              ;
            let i = index
          ">
          <td>
            <h2 class="table-avatar">
              <!-- <a class="avatar avatar-sm me-2"><img class="avatar-img rounded-circle"
                  [src]="avatarSrc(consultation)" [alt]="consultation.patientFirstName + ' ' + consultation.patientLastName" image /></a> -->
              <a style="font-family: 'Gotham Rounded Bold'; font-weight: Bold">
                {{ consultation.patientFirstName }} {{ consultation.patientLastName }}
              </a>
            </h2>
          </td>
          <td>
            <span class="d-block">
              {{ consultation.date | date : "dd/MM/YYYY" }}</span>
            <span class="apt-time"> {{ consultation.time  }}</span>
          </td>
          <td style="width: 25%">
            <span *ngFor="let tag of consultation.motifs" style="display: block" class="tag-td mx-1 my-1" style="
                float: left;
                margin-right: 5px;
                border-radius: 0.3rem;
                color: white;
                padding: 4px;
              " [ngStyle]="{ 'background-color': tag.color || 'gray' }">{{ tag.text }}</span>
          </td>
          <td [innerHTML]="consultation.diagnostic?.split('\n')?.join('<br/>')" style="
              max-width: 200px !important;
              word-break: break-word;
              white-space: normal;
              text-align: left;
            "></td>
          <td class="text-center" *ngIf="doctor.speciality.label=='Ophtalmologue' && doctor.cliniqueId">
            <span *ngIf="consultation.paid; else notPaid" class="badge"
              style="background-color: #d4edda; color: #155724;  border: 1px solid #c3e6cb; padding: 6px 12px; border-radius: 12px;">
              <i class="fas fa-check-circle me-1"></i> Payé
            </span>
            <ng-template #notPaid>
              <span class="badge" style="background-color: #f8d7da; color: #721c24; border: 1px solid #f5c6cb; padding: 6px 12px; border-radius: 12px"> <i class="fas fa-times-circle me-1"></i> Non payé </span>
            </ng-template>
          </td>

          <td class="text-start">
            <div class="table-action">
              <a *ngIf="doctor.speciality.label == 'Ophtalmologue'" title="View ordonnance Consultation" [routerLink]="[
                  'patients',
                  consultation.patientId,
                  'consultations',
                  consultation.id,
                  'ordonnance'
                ]" class="btn btn-sm bg-info-light mx-2">
                <i class="feather-printer"></i>
              </a>
                 <a *ngIf="doctor.speciality.label == 'Ophtalmologue' && doctor.cliniqueId " title="Update Exploration" [routerLink]="[
                  'patients',
                  consultation.patientId,
                  'consultations',
                  consultation.id,
                  'edit-exploration'
                ]" class="btn btn-sm bg-success-light">
                <i class="feather-eye"></i>
              </a>
              <a title="Update Consultation" [routerLink]="[
                  'patients',
                  consultation.patientId,
                  'consultations',
                  consultation.id,
                  'edit'
                ]" class="btn btn-sm bg-success-light">
                <i class="feather-edit-3"></i>
              </a>
              <a title="Delete Consultation" *ngIf="!consultation.paid" (click)="onDeleteConsultation(i)" class="btn btn-sm bg-danger-light">
                <i class="feather-trash"></i>
              </a>
              <app-drop-down-menu *ngIf="
                  doctor.speciality.label != 'Ophtalmologue' &&
                  (doctor.consultationCNAMAP4 ||
                    doctor.consultationCNAMAP2 ||
                    doctor.consultationCNAMAP3) || doctor.actionplan === true || doctor.actionReduction
                " >
                <a title="Ajout" routerLinkActive="router-link-active" class="btn btn-sm bg-success-light" #trigger
                  trigger>
                  <i class="feather feather-menu"></i>
                </a>
                <ul class="menu" #content content>
                  <li>
                    <a *ngIf="
                        doctor.speciality.label != 'Ophtalmologue' &&
                        doctor.consultationCNAMAP2
                      " title="View ordonnance Consultation" [routerLink]="[
                        'patients',
                        consultation.patientId,
                        'consultations',
                        consultation.id,
                        'ap2'
                      ]" class="btn btn-sm mx-2">
                      <span>AP2</span>
                    </a>
                  </li>
                  <li>
                    <a *ngIf="
                        doctor.speciality.label != 'Ophtalmologue' &&
                        doctor.consultationCNAMAP3
                      " title="View ordonnance Consultation" [routerLink]="[
                        'patients',
                        consultation.patientId,
                        'consultations',
                        consultation.id,
                        'ap3'
                      ]" class="btn btn-sm mx-2">
                      <span>AP3</span>
                    </a>
                  </li>
                  <li>
                    <a *ngIf="
                        doctor.speciality.label != 'Ophtalmologue' &&
                        doctor.consultationCNAMAP4
                      " title="View ordonnance Consultation" [routerLink]="[
                        'patients',
                        consultation.patientId,
                        'consultations',
                        consultation.id,
                        'ap4'
                      ]" class="btn btn-sm mx-2">
                      <span>AP4</span>
                    </a>
                  </li>
                  <li>
                    <a *ngIf="
                        doctor.speciality.label != 'Ophtalmologue' &&
                       doctor.actionReduction
                      " title="View orthopedique Consultation" [routerLink]="[
                        'patients',
                        consultation.patientId,
                        'consultations',
                        consultation.id,
                        'orthopedique'
                      ]" class="btn btn-sm mx-2">
                      <span>Rééducation </span>
                    </a>
                  </li>
                      <li>
                    <a *ngIf="
                        doctor.speciality.label != 'Ophtalmologue' &&
                       doctor.actionplan || doctor.actionReduction
                      " title="View Rééducation Consultation" [routerLink]="[
                        'patients',
                        consultation.patientId,
                        'consultations',
                        consultation.id,
                        'reeducation'
                      ]" class="btn btn-sm mx-2">
                      <span> {{doctor.actionplan === true ? 'Plan de Action' : 'Planning de Rééducation'}}</span>
                    </a>
                  </li>
                </ul>
              </app-drop-down-menu>
            </div>
          </td>
        </tr>
      </ng-container>

      <ng-template #empty>
        <tr>
          <td colspan="8" style="text-align: center">
            <span style="text-align: center; width: 100%">
              {{ emptyMessage || 'Pas de consultations !' }}
            </span>
          </td>
        </tr>
      </ng-template>
    </tbody>
  </table>
  <app-pagination (content)="doctorConsultations = $event" [pageRequest]="pageRequest"></app-pagination>
</div>
